async function copyToClipboard(textToCopy) {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
    } else {
        // Use the 'out of viewport hidden text area' trick
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;

        // Move textarea out of the viewport so it's not visible
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
        } catch (error) {
            console.error(error);
        } finally {
            textArea.remove();
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.content-clipboard');
    const tooltips = document.querySelectorAll('.tooltip__body-hint-copy');
    const socialBlock = document.querySelector('.content__info-social');

    const share = document.querySelector('.content__share-button');
    share.addEventListener('click', async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    url: window.location.href
                });
            } catch (err) {
                console.log(err)
            }
        } else {
            if (socialBlock.style.display === 'flex') {
                socialBlock.style.display = 'none'
            } else {
                socialBlock.style.display = 'flex'
            }
        }
    })

    triggers.forEach((item, i) => {
        item.addEventListener('click', async () => {
            try {
                await copyToClipboard(window.location.href);
            } catch (err) {
                console.error(err);
            }
            // tooltips[i].style.display = 'flex';
            item.querySelector('img').src = '/static/news/img/base/check_mark.png';
            let oldTitle = item.title;
            item.title = item.dataset.copiedTitle;

            setTimeout(() => {
                item.querySelector('img').src = '/static/news/img/base/share.svg';
                item.title = oldTitle;
                // tooltips[i].style.display = 'none';
            }, 2000)
        })
    })
});